// extracted by mini-css-extract-plugin
export default {"articles":"Blog_articles__d6YUa","content":"Blog_content__OXyJZ"};